import { Component } from '@angular/core';
import { LeaderboardType, LeaderboardV2Entry, LeaderboardV2Query, LeaderboardV2Service, MemberQuery, PopulationQuery } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import * as _moment from 'moment';
import { Observable, firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { calculateAge, getKidType, KidTypeT } from 'src/app/shared/utilities/age-ranges';
import { Populations } from 'src/app/shared/utilities/populations';
@Component({
  selector: 'fgb-fantasy-games-page',
  templateUrl: './fantasy-games-page.component.html',
  styleUrls: ['./fantasy-games-page.component.scss'],
})
export class FantasyGamesPageComponent {
  screenType = ScreenType;
  LeaderboardType: LeaderboardType = LeaderboardType.FantasyPoints;
  currentUser: LeaderboardV2Entry | undefined;
  isClub1901: boolean;
  isKid: boolean;
  kidType$: Observable<KidTypeT>;

  constructor(
    private leaderboardV2Service: LeaderboardV2Service,
    private leaderboardV2Query: LeaderboardV2Query,
    private populationQuery: PopulationQuery,
    private memberQuery: MemberQuery
  ) {}

  ngOnInit() {
    firstValueFrom(this.leaderboardV2Service.fetchLeaderboardV2(undefined, this.LeaderboardType)).then(() => {
      this.currentUser = this.leaderboardV2Query.getLeaderboardV2().find((entry) => entry.IsCurrentUser);
    });
    this.isClub1901 = this.populationQuery.userInPopulation([Populations.Club1901]);
    this.isKid = this.populationQuery.userInPopulation([Populations.Kids]);
    this.kidType$ = this.memberQuery.selectMemberDetails().pipe(
      map((m) => (m ? getKidType(calculateAge(new Date(m.DOB))) : 'Other'))
    );
  }
}
